import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';

const usePaymentMethodLabelsMap = ()=>{
    const { getLabel  } = useIntl();
    return React__default.useMemo(()=>({
            [PaymentMethod.APPLE_PAY]: getLabel('checkout.payment.method.applepay'),
            [PaymentMethod.GOOGLE_PAY]: getLabel('checkout.payment.method.googlepay'),
            [PaymentMethod.BANCONTACT_CARD]: getLabel('checkout.payment.method.bancontactCard'),
            [PaymentMethod.BANCONTACT_MOBILE]: getLabel('checkout.payment.method.bancontactMobile'),
            [PaymentMethod.CASH_ON_DELIVERY]: getLabel('checkout.payment.method.cashOnDelivery'),
            [PaymentMethod.CREDITCARD]: getLabel('checkout.payment.method.creditcard'),
            [PaymentMethod.FAKE]: 'Fake payment',
            [PaymentMethod.IDEAL]: getLabel('checkout.payment.method.ideal'),
            [PaymentMethod.KLARNA_ACCOUNT]: getLabel('checkout.payment.method.klarna_account'),
            [PaymentMethod.KLARNA]: getLabel('checkout.payment.method.klarna'),
            [PaymentMethod.MBWAY]: getLabel('checkout.payment.method.mbway'),
            [PaymentMethod.MOBILE_PAY]: getLabel('checkout.payment.method.mobilepay'),
            [PaymentMethod.MULTIBANCO]: getLabel('checkout.payment.method.multibanco'),
            [PaymentMethod.ONEY]: getLabel('checkout.payment.method.oney'),
            [PaymentMethod.PAYPAL]: getLabel('checkout.payment.method.paypal'),
            [PaymentMethod.SEPA_DIRECT_DEBIT]: getLabel('checkout.payment.method.sepadirectdebit'),
            [PaymentMethod.SWISH]: getLabel('checkout.payment.method.swish')
        })
    , [
        getLabel
    ]);
};

export { usePaymentMethodLabelsMap };
//# sourceMappingURL=use-payment-method-labels-map.js.map
